module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("292sz"))).then(() => parcelRequire('7XV9p'));